import { render, staticRenderFns } from "./Mrejected.vue?vue&type=template&id=1234a036&scoped=true&"
import script from "./Mrejected.vue?vue&type=script&lang=js&"
export * from "./Mrejected.vue?vue&type=script&lang=js&"
import style0 from "./Mrejected.vue?vue&type=style&index=0&id=1234a036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1234a036",
  null
  
)

export default component.exports